import { IconButton } from 'component/Button/IconButton'
import { Modal } from 'component/Modal'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { UploadQr } from 'page/ProfileScreen/UploadQrModal/UploadQr'
import { uploadQrModal } from 'page/ProfileScreen/UploadQrModal/UploadQrModalStore'

export const UploadQrModal = observer(() => {

  const onClose = useLatestCallback(async () => {
    uploadQrModal.close()
  })

  const onDone = useLatestCallback(async () => {
    uploadQrModal.close()
  })

  return <Modal width={640} round={24}>
    <Space height={64} pad={[0, 16]} right>
      <IconButton action={onClose}>
        <Icon size={32} name="close" />
      </IconButton>
    </Space>
    <Space center>
      <UploadQr size={320} onDone={onDone} />
    </Space>
    <Space pad={[0, 0, 32, 0]}>
      <Typo size={24} first center balance>
        {i18n('ScanQrToTakeSelfieWithYourPhoneOrUploadPhoto')}
      </Typo>
    </Space>
  </Modal>
})
